<template>
  <div class="pie-chart-container" id="vessel_record_by_flag">
    <apexchart ref="apex-chart-auxiliary-boiler" type="pie" height="auto" :options="chartOptions" :series="vessels"></apexchart>
    <div v-if="showModal" class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
      <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Vessels (By Auxiliary Boiler)<span v-if="loading"></span><span v-else><span class="h5"> - </span><span class="text-danger text-uppercase font-weight-bold h5">{{items[0].engine_aux_maker_name}}</span></span></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading">
              <app-loading></app-loading>
            </div>
            <div class="card border-0" v-else>
              <div class="card-body p-1">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class=" table-responsive">
                      <table class="table table-bordered table-sm">
                        <thead>
                        <tr class="text-center text-uppercase font-weight-bold" style="background: #e1e1e1;">
                          <th scope="col" class="border-true">#</th>
                          <th scope="col" class="border-true">Vessel Name</th>
                          <th scope="col" class="border-true">Auxiliary Boiler Name</th>
                          <th scope="col" class="border-true">Auxiliary Boiler Type</th>
                          <th scope="col" class="border-true">Management Company</th>
                          <th scope="col" class="border-true">Management Office</th>
                          <th scope="col" class="border-true">Fleet</th>
                          <th scope="col" class="border-true">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(data, index) in items" :key="index" class="text-center">
                          <th scope="row" class="border-true"><div class="my-1">{{index+1}}</div></th>
                          <td class="border-true"><div class="my-1">{{ data.name }}</div></td>
                          <td class="border-true"><div class="my-1">{{ data.engine_aux_maker_name.toUpperCase() }}</div></td>
                          <td class="border-true"><div class="my-1">{{ data.engine_aux_type_name ? data.engine_aux_type_name.toUpperCase() : '' }}</div></td>
                          <td class="border-true"><div class="my-1">{{ data.management_company_name.toUpperCase() }}</div></td>
                          <td class="border-true"><div class="my-1">{{ data.management_office_name.toUpperCase() }}</div></td>
                          <td class="border-true"><div class="my-1">{{ data.fleet_name.toUpperCase() }}</div></td>
                          <td class="border-true">
                            <button class="e-btn e-btn-blue e-btn-sm e-text-white p-1" @click="showVessel(data.id)">
                              <font-awesome-icon icon="eye"  />
                              View
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import axios from 'axios';
import ApexCharts from 'apexcharts';
import {mapActions, mapGetters} from "vuex";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import appLoading from "@/components/elements/AppLoading.vue";
import {ExcelService} from "@/services/ExcelService";
import {VesselService} from "@/services/VesselService";

export default {
  name: "VesselRecordAuxiliaryBoilerChart",
  props:{
    series : {
      type : Array,
      default: null
    },
    labels : {
      type : Array,
      default : null
    },
    legendPosition : {
      type : String,
      default : 'left'
    },
    categories:{
      type: Array,
      default: null
    },
    years:{
      type: Array,
      default: null
    },
    categoryObject:{
      type:Array|Object,
      default:null
    },
    office:{
      type:String|Number,
      default:null,
    },
  },
  mixins:[PaginationMixin],
  components:{appLoading},
  data() {
    return {
      items: [],
      vessels: [],
      vessel_engine_aux_maker_id: null,
      selectedSegment: null,
      showModal: false,
      year:null,
      loading:false,
      currentEvent:null,
      chartOptions: {
        grid: {
          padding: {
            top: 100,
            right: 0,
            bottom: 100,
            left: 0
          }
        },
        plotOptions: {
          pie: {
            customScale: this.getLegendCount(this.labels?.length || 0),
          }
        },
        chart: {
          height: '100%',
          width: '100%',
          type: 'pie',
          responsive: true,
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const label = this.labels[config.dataPointIndex];
              const value = this.series[config.dataPointIndex].vessel_engine_aux_maker_count;
              this.vessel_engine_aux_maker_id = this.series[config.dataPointIndex].id
              this.selectedSegment = { label, value };
              this.getVesselRecordByAuxiliaryBoilerList(this.vessel_engine_aux_maker_id);
              this.showModal = true;
              this.disableBodyScroll();
            },
          },
        },
        labels: this.labels,
        tooltip: {
          enabled: true,
          style : {
            color : '#fff'
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize : '32px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: new Array(this.series.length).fill('#fff'),
          },
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.9,
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              color: '#000',
              opacity: 0.45
            }
          },
          dropShadow: {
            enabled: false,
            top: 1,
            left: 1,
            blur: 1,
            color: '#000',
            opacity: 0.45
          },
          formatter: function(seriesName, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          verticalAlign: 'center',
          floating: false,
          fontSize: '24px',
          fontFamily: 'Helvetica, Arial',
          fontWeight: 'bold',
          markers: {
            width: 8,
            height: 8,
            radius: 8,
            // offsetX: -10,
            // offsetY: -5,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5
          },
          // offsetX: 10,
          // offsetY: 0,
          formatter: function(seriesName, opts) {
            return seriesName + ": " + '<strong style="color: #d3313c;">' + opts.w.globals.series[opts.seriesIndex] + '</strong>';
          }
        },
      },
    }
  },
  mounted() {
    this.vessels = this.series.map(item => item.vessel_engine_aux_maker_count);
    const chart = new ApexCharts(this.$el.querySelector(".pie-chart-container"), this.chartOptions);
    chart.render();
  },
  methods:{
    ...mapActions([
      'getDashboardVesselManagement',
      'getMngmtOfficeKeys',
      'getVesselSummaryList',
    ]),
    getLegendCount(count) {
      if (count <= 14) return 1;
      return 1 + Math.ceil((count - 14) / 5) * 0.5;
    },
    closeModal() {
      this.enableBodyScroll();
      this.showModal = false;
      this.selectedSegment = null;
    },
    disableBodyScroll() {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '17px'; // Optional: Prevent content from shifting
    },
    enableBodyScroll() {
      document.body.style.overflow = '';
      document.body.style.paddingRight = ''; // Optional: Reset padding
    },
    async getVesselRecordByAuxiliaryBoilerList(vessel_engine_aux_maker_id) {
      try {
        this.loading = true;
        let param = {}
        if (vessel_engine_aux_maker_id) {
          param.vessel_engine_aux_maker_id = vessel_engine_aux_maker_id;
        }
        const response = await axios.post('/kids/getVesselRecordByAuxiliaryBoilerList', param);
        this.items = response.data;
        this.loading = false;
      } catch (error) {
        console.error('Error sending POST request:', error);
        throw error;
      }
    },
    async showVessel(vesselId) {
      const route= this.$router.resolve(
        {
          name: 'VesselParticular',
          params: {
            id: vesselId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async getGraphImage() {
      const chart = this.$refs["apex-chart-auxiliary-boiler"].chart;
      const { imgURI } = await chart.dataURI();
      const byteString = atob(imgURI.split(',')[1]);
      const mimeString = imgURI.split(',')[0].split(':')[1].split(';')[0];
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uintArray = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: mimeString });
      const formData = new FormData();
      formData.append("chart_image", blob, "chart.png");
      formData.append("report_type", 'AUXILIARY BOILER');


      swal.fire({
        'title': `Exporting Vessel Graph Summary (AUXILIARY BOILER)`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/color/400/pie-chart--v1.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const printResponse = await VesselService.printSummaryOfManagingVesselGraph(formData);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`graph_by_auxiliary_boiler_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>

<style scoped>
.border-true{
  border: 1px solid #b1b1b1 !important;
}

</style>
